import {useCallback, useEffect, useState} from 'react'
import 'survey-core/defaultV2.min.css'
import {StylesManager, Model} from 'survey-core'
import {Survey} from 'survey-react-ui'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {
  createStudentClearanceRequest,
  getSurveyApplicationDetail,
  StudentClearanceCreatePayload,
  submitSurveyApplication,
  SurveyApplicationDetail,
} from '../../CustomController'
import 'survey-core/survey.i18n'

StylesManager.applyTheme('defaultV2')

type SurveyAnswerNavigationState = {
  studentClearanceReturnTo?: string
  studentClearanceRequest?: StudentClearanceCreatePayload
}

const SurveyAnswer = () => {
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const navigationState = location.state as SurveyAnswerNavigationState | null
  const [survey, setSurvey] = useState<any>('')
  const [surveyApplication, setSurveyApplication] = useState<SurveyApplicationDetail | null>(null)
  const [isloading, setisloading] = useState(true)
  const [courseOutcome, setCourseOutcome] = useState(false)
  const [organizationOutcome, setOrganizationOutcome] = useState(false)
  const [organizationEducationPurpose, setOrganizationEducationPurpose] = useState(false)

  useEffect(() => {
    const surveyAppId = params.SurveyAppId ? Number(params.SurveyAppId) : undefined

    if (!surveyAppId) {
      setisloading(false)
      return
    }

    getSurveyApplicationDetail(surveyAppId)
      .then((detail) => {
        if (!detail) {
          return
        }

        try {
          const jsp = detail.surveyJson ? JSON.parse(detail.surveyJson) : ''
          setSurvey(jsp)
        } catch (error) {
          console.error('Survey JSON parse hatası:', error)
          setSurvey('')
        }

        setCourseOutcome(detail.courseOutcomeIsChecked)
        setOrganizationOutcome(detail.organizationOutcomeIsChecked)
        setOrganizationEducationPurpose(detail.organizationEducationPurposeIsChecked)
        setSurveyApplication(detail)
      })
      .finally(() => {
        setisloading(false)
      })
  }, [params.SurveyAppId])

  console.log(courseOutcome)

  const Outcomes = [
    {courseOutcome: courseOutcome},
    {organizationOutcome: organizationOutcome},
    {organizationEducationPurpose: organizationEducationPurpose},
    {courseId: params.CourseId},
    {surveyApplicationId: surveyApplication?.id},
  ]
  const hasOutcomeSurvey = courseOutcome || organizationOutcome || organizationEducationPurpose

  let md = new Model(survey)
  md.locale = 'tr'
  md.focusFirstQuestionAutomatic = false
  md.showCompletedPage = !hasOutcomeSurvey

  const alertResults = useCallback(
    (sender: any) => {
      const results = JSON.stringify(sender.data)

      if (!surveyApplication) {
        return
      }

      const payload = {
        id: surveyApplication.id,
        surveyId: surveyApplication.surveyId,
        name: results,
        isCompleted: true,
      }

      if (hasOutcomeSurvey && !navigationState?.studentClearanceRequest) {
        void submitSurveyApplication(payload).catch((error) => {
          console.error('Survey submit hatası:', error)
        })
        if (courseOutcome) {
          navigate('/CourseOutcomeSurvey', {state: Outcomes})
        } else if (organizationOutcome) {
          navigate('/OrganizationOutcomeSurvey', {state: Outcomes})
        } else {
          navigate('/EducationPurposeOutcomeSurvey', {state: Outcomes})
        }
        return
      }

      submitSurveyApplication(payload)
        .then(async () => {
          if (
            navigationState?.studentClearanceReturnTo &&
            navigationState.studentClearanceRequest
          ) {
            await createStudentClearanceRequest(navigationState.studentClearanceRequest)
            navigate(navigationState.studentClearanceReturnTo, {
              replace: true,
              state: {
                studentClearanceFeedback: {
                  type: 'success',
                  message: 'Anket tamamlandı ve ilişik kesme başvurunuz oluşturuldu.',
                },
              },
            })
            return
          }

          if (navigationState?.studentClearanceReturnTo) {
            navigate(navigationState.studentClearanceReturnTo, {replace: true})
            return
          }

          navigate('/Dashboard')
        })
        .catch((error) => {
          if (!navigationState?.studentClearanceReturnTo) {
            console.error('Survey submit hatası:', error)
            return
          }

          const message =
            typeof error?.response?.data === 'string'
              ? error.response.data
              : 'Anket veya ilişik kesme başvurusu tamamlanamadı.'
          navigate(navigationState.studentClearanceReturnTo, {
            replace: true,
            state: {
              studentClearanceFeedback: {type: 'danger', message},
            },
          })
        })
    },
    [
      surveyApplication,
      courseOutcome,
      organizationOutcome,
      organizationEducationPurpose,
      hasOutcomeSurvey,
      navigate,
      navigationState,
    ]
  )

  md.onComplete.add(alertResults)

  return !isloading ? (
    <div style={{backgroundColor: '#f3f3f3', height: '100vh'}}>
      {' '}
      <Survey model={md} locale='tr' />{' '}
    </div>
  ) : (
    <div style={{backgroundColor: '#f3f3f3', height: '100vh'}}></div>
  )
}

export {SurveyAnswer}
